// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__NZPbO","highlighted":"styles_highlighted__50Mdz","defaultText":"styles_defaultText__Z3eKD"};